<template>
  <v-app class="app-flex-root">
    <Navbar v-on:logout="user = null" :user="user" />
    <v-main class="grey lighten-3 app-flex-main">
      <router-view v-if="!$route.query.loginToken || !$route.query.userId"></router-view>

      <v-row v-else class="fill-height ma-0" align="center" justify="center">
        <div class="text-center">
          <h1 class="grey--text mr-12">Logging in...</h1>
          <v-progress-circular v-if="!loginError" indeterminate color="grey"></v-progress-circular>
          <v-alert class="mt-2" color="red" v-else dark icon="mdi-alert-circle" border="right">
            Login error! This login token has expired.
          </v-alert>
        </div>
      </v-row>
    </v-main>
    <v-footer class="pa-3 app-footer" color="primary" padless>
      <v-row justify="center" no-gutters>
        <v-btn v-for="link in links" :key="link.url" color="white" text rounded class="my-2 mx-1" :href="link.url"
          target="_blank">
          <v-icon class="mr-2">{{ link.icon }}</v-icon> {{ link.name }}
        </v-btn>
        <v-col class="py-4 text-center white--text" cols="12">
          {{ new Date().getFullYear() }} — <strong>TinyGS</strong>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script setup>
/**
 * Migrated from Options API to Composition API.
 * - data() properties moved to refs/reactive
 * - methods converted to functions
 * - mounted() logic moved to onMounted
 * - Preserved router, Vuetify, and global state integration
 * - All template bindings and styles unchanged
 */
import { ref, onMounted, getCurrentInstance } from 'vue'
import Navbar from "./components/Navbar.vue";
import axios from './plugins/axios'

// State
const user = ref(null)
const loginError = ref(false)
const links = [
  {
    icon: "mdi-github",
    name: " GitHub",
    url: "https://github.com/G4lile0/tinyGS",
  },
  {
    icon: "mdi-file-document-multiple-outline",
    name: " Wiki",
    url: "https://github.com/G4lile0/tinyGS/wiki",
  },
  {
    icon: "mdi-map-marker-question-outline",
    name: " FAQ",
    url: "https://github.com/G4lile0/tinyGS/wiki/FAQ",
  },
  {
    icon: "mdi-forum",
    name: " Telegram",
    url: "https://t.me/joinchat/DmYSElZahiJGwHX6jCzB3Q",
  },
  {
    icon: "mdi-mastodon",
    name: "mastodon",
    url: "https://mastodon.social/@tinygs",
  },
  {
    icon: "$twitter",
    name: " Twitter",
    url: "https://twitter.com/tiny__GS",
  },
  {
    icon: "mdi-linkedin",
    name: "LinkedIn",
    url: "https://www.linkedin.com/company/102882109",
  },
  { icon: "", name: "T&C", url: "/terms" },
]

// Access global properties
const { proxy } = getCurrentInstance()

// Methods
async function login() {
  if ("userId" in localStorage) {
    proxy.$router.push(`/user/${user.value}`);
    return;
  }
  let params = {
    loginToken: proxy.$route.query.loginToken,
    userId: proxy.$route.query.userId,
  };
  try {
    const { data } = await axios.post(`/v1/login`, params);
    // console.log(data);
    localStorage.setItem('sessionToken', data.sessionToken);
    localStorage.setItem('userId', params.userId);
    user.value = params.userId;
    proxy.$router.push(`/user/${params.userId}`);
  } catch (err) {
    loginError.value = true;
  }
  // put authenticate and save token and remove query string -> proxy.$router.push(proxy.$route.path)
}

function navigate(l) {
  window.location = l;
}

// Lifecycle
onMounted(() => {
  if ("userId" in localStorage) {
    user.value = localStorage.userId;
  }
  if (proxy.$route.query.loginToken && proxy.$route.query.userId) {
    login();
  }
})

// Expose to template
defineExpose({ user, loginError, links, login, navigate })
</script>
<style scoped>
.app-flex-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.app-flex-main {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.app-footer {
  flex-shrink: 0;
  width: 100%;
}

@media (max-width: 600px) {
  .app-footer {
    font-size: 0.95em;
    padding-bottom: 56px;
  }
}
</style>